import { gql } from '@apollo/client'

const UPDATE_CHALLENGE_SIMPLE_DETAILS_MUTATION = gql`
  mutation updateChallengeSimpleDetails(
    $id: ID!
    $data: ChallengeSimpleDetailsInput!
  ) {
    updateChallengeSimpleDetails(id: $id, data: $data) {
      id
      description
      updatedAt
      updatedBy {
        id
        name
      }
      position
    }
  }
`

export default UPDATE_CHALLENGE_SIMPLE_DETAILS_MUTATION
